// Client-side search-input rules mirrored from Memory's public bounded search contract. The server-side
// Memory service remains authoritative and re-validates every request; this mirror keeps blank navigation
// local and prevents the browser from knowingly sending an oversized query.

/** MIRRORED_CONTRACT: MAX query length enforced by Memory.searchMemoryIndex. */
export const MAX_MEMORY_SEARCH_QUERY_CHARS = 400;

/** The canonical query the client sends. Blank remains ordinary tree navigation and sends no request. */
export function normaliseMemorySearchQuery(input: string): string {
  return input.trim();
}

/** True only for a nonblank query that fits the owning Memory endpoint's public bound. */
export function isValidMemorySearchQuery(query: string): boolean {
  return query.length > 0 && query.length <= MAX_MEMORY_SEARCH_QUERY_CHARS;
}
